import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Regisztracio from './Regisztracio';
import Review from './Review';

// A /megrendeles/:megrendelesID oldal: a mentett megrendelés. Fizetett → áttekintés; még nem fizetett →
// a regisztrációs oldal a betöltött megrendeléssel (fizetés folytatása, módosítás, törlés).
function MegrendelesBetolto({ megrendelesID, ...props }) {
    const navigate = useNavigate();
    const [megrendeles, setMegrendeles] = useState(undefined);

    useEffect(() => {
        props.callAPI("General.getMegrendeles", { megrendelesID: Number(megrendelesID) }, function (resp) {
            props.setFelhasznalo(resp.data.felhasznalo);
            setMegrendeles(resp.data.megrendeles);
        }, function () {
            // nem található (pl. lejárt és törölt, vagy más felhasználóé): vissza a listára
            navigate('/rendezvenyek', { replace: true });
        });
    }, [megrendelesID]);

    if (megrendeles === undefined) {
        return <div className="betoltes">Töltés...</div>;
    }
    if (Number(megrendeles.Fizetessikeres) === 1) {
        return <Review {...props} betoltottMegrendelesData={megrendeles} />;
    }
    return <Regisztracio {...props} rendezvenyID={megrendeles.rendezveny.Id} betoltottMegrendelesData={megrendeles} />;
}

export default function MegrendelesOldal({ vedett, ...props }) {
    const { megrendelesID } = useParams();
    return vedett(
        <MegrendelesBetolto key={megrendelesID} megrendelesID={megrendelesID} {...props} />,
        { cel: '/megrendeles/' + megrendelesID }
    );
}
